
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/[chartId]",
      function () {
        return require("private-next-pages/create/[chartId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/[chartId]"])
      });
    }
  